import { combineReducers } from 'redux';
import rootSagas from './sagas';
import {
  SCOPE,
  SCOPE_REQUEST,
} from './types';
import coreReducer from './reducer';
import distributionSagas from './sagas';

export { default as selectors } from './selectors';

import { createReducer } from '@api/createRequestStore';

export {
  SCOPE,
  SCOPE_REQUEST,
};

export const reducer = combineReducers({
  core: coreReducer,
  request: createReducer(SCOPE),
});

export const sagas = [
  ...rootSagas,
  ...distributionSagas,
];
